import { IconButton, Menu, MenuButton, MenuList, Portal, Tooltip } from '@elkaso-app/web-design';
import { FilterIcon } from 'components/base-table/icons';

interface IBaseFilterButton {
  isOpen: boolean;
  onOpen: () => void;
  onClose: () => void;
  isActive: boolean;
  formComponent: JSX.Element;
}

export const BaseFilterButton = ({ isOpen, onOpen, onClose, isActive, formComponent }: IBaseFilterButton) => {
  return (
    <Menu isOpen={isOpen} onClose={onClose} onOpen={onOpen}>
      <Tooltip label='Filter'>
        <MenuButton
          as={IconButton}
          aria-label='filter-btn'
          icon={<FilterIcon fill={isActive ? 'white' : 'gray.500'} />}
          variant={isActive ? 'solid' : 'outline'}
          colorScheme={isActive ? 'red' : 'gray'}
          size='sm'
          borderRadius='md'
          boxShadow='sm'
          _hover={{ boxShadow: 'md' }}
        />
      </Tooltip>
      {/* Portaled: BaseTableContainer clips in-flow menus (overflowY auto + zIndex 0
          stacking context), truncating the filter form on short tables. The portal
          container itself is unlayered (z auto), so the list needs an explicit
          zIndex — filters must paint above ALL page content, including sticky
          table headers (e.g. the Prices matrix thead at zIndex 2). */}
      <Portal>
        <MenuList zIndex='popover'>{formComponent}</MenuList>
      </Portal>
    </Menu>
  );
};
